var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.25a.75.75 0 01.75.75v2A2.75 2.75 0 0115 18.75H3A2.75 2.75 0 01.264 16.27L.25 16v-2a.75.75 0 011.5 0v2l.006.124A1.25 1.25 0 003 17.25h12A1.25 1.25 0 0016.25 16v-2a.75.75 0 01.75-.75zm-8-13a.75.75 0 01.75.75v10.19l3.72-3.72a.75.75 0 011.06 1.06l-5 5a.75.75 0 01-1.004.052l-.056-.052-5-5-.052-.057a.75.75 0 011.056-1.055l.056.051 3.72 3.72V1A.75.75 0 019 .25z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.76926beea2610d17ba1165b35a5ca918.svg";
export { ForwardRef as ReactComponent };